import {Controller} from "stimulus"

export default class extends Controller {

    static targets = ['value']

    copy() {
        var copyText = this.valueTarget;

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        document.execCommand("copy");
    }
}
